module.exports = __webpack_public_path__ + "static/media/italian.b60437f0.jpg";